<template>
  <div :class="['row mx-0', addContainerClasses]">
    <div class="col-12 col-md-4 col-xl-3 font-weight-bold">Estrich</div>
    <div class="col-12 col-md-8 col-xl-9">
      <div class="row">
        <div class="col-6 d-flex flex-column justify-content-between">
          <span class="d-block pb-2">Trockenestrich<br/><small class="d-none d-md-block">(Gipsfaserplatte oder zementgebundene Spanplatte)</small></span>
          <div class="d-flex flex-column align-items-start align-items-xl-start flex-sm-wrap flex-sm-row">
            <button type="button"
              v-for="(item, index) in items.dry"
              :key="index"
              :class="['btn btn-sm btn-outline-filter', filterUiState('screed', item.value)]"
              v-on:click="selectValue(item.value)">{{ item.title }}</button>
          </div>
        </div>
        <div class="col-6 d-flex flex-column justify-content-between">
          <span class="d-block pb-2">Nassestrich<br/><small class="d-none d-md-block"><br/></small></span>
          <div class="d-flex flex-column align-items-start align-items-xl-start flex-sm-wrap flex-sm-row">
            <button type="button"
              v-for="(item, index) in items.wet"
              :key="index"
              v-bind:item="item"
              :class="['btn btn-sm btn-outline-filter', filterUiState('screed', item.value)]"
              v-on:click="selectValue(item.value)">{{ item.title }}</button>

              <button type="button"
              v-for="(item, index) in items.nowet"
              :key="index + items.wet.length"
              v-bind:item="item"
              :class="['btn btn-sm btn-outline-filter', filterUiState('screed', item.value)]"
              v-on:click="selectValue(item.value)">{{ item.title }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { mapGetters } from 'vuex'
import { trackCallstack } from '../../../helper/tracker'

export default {
  name: 'StoCscFilterSectionScreed',
  props: {
    addContainerClasses: String
  },
  data: function () {
    return {
      items: {
        dry: [
          { title: '≥ 18 mm', value: 'd-18' },
          { title: '≥ 20 mm', value: 'd-20' },
          { title: '≥ 22 mm', value: 'd-22' },
          { title: '≥ 25 mm', value: 'd-25' }
        ],
        wet: [
          { title: '≥ 50 mm', value: 'w-50' },
          { title: '≥ 60 mm', value: 'w-60' },
          { title: '70 mm', value: 'w-70' },
        ],
        nowet: [
          { title: 'ohne', value: 'nw-0' }
        ]
      }
    }
  },
  computed: {
    ...mapGetters({
      filterUiState: 'filter/uiState',
      filterState: 'filter/state'
    })
  },
  methods: {
    selectValue: function (value) {
      let title = ''
      let result = this.items.dry.filter(item => item.value === value)
      if (result.length <= 0) result = this.items.wet.filter(item => item.value === value)
      if (result.length > 0) title = result[0].title

      const uiState = this.filterUiState('screed', value)

      const category = value === ('w-50' || 'w-60' || 'w-70' || 'nw-0') ? 'Estrich - Nassestrich' : 'Estrich - Trockenestrich'

      this.$gtm.trackEvent({
        event: 'filter',
        category: category,
        action: uiState === 'pending' ? 'hinzufügen' : (uiState === 'active' ? 'reaktivieren' : 'aktivieren'),
        label: title,
        value: Number(value.split('-')[1])
      })

      this.$store.dispatch('filter/setValue', {
        name: 'screed',
        title: category + ' ' + title,
        value: value
      }).then(() => trackCallstack(this.$gtm, this.filterState._callstack))
    }
  }
}

</script>
